import { AnalyticsContext } from './context';
import useAnalyticsProvider from './useAnalyticsProvider';
import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  debug?: boolean;
}

export const AnalyticsProvider = ({ children, debug }: IProps) => {
  const context = useAnalyticsProvider(debug);
  return (
    <AnalyticsContext.Provider value={context}>
      {children}
    </AnalyticsContext.Provider>
  );
};
